module.exports = __webpack_public_path__ + "img/全面测试.ccf261a4.svg";